import { INFINITE_BOUNDS } from "apparatus/driver";
import { createApparatus } from "apparatus/library";
import { P, Segments } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import Flags from "flags";
import { Path, Point } from "paper";
export class Line {
    constructor() {
        this.shouldUseBoundsCenter = true;
        this.drivers = [
            Object.assign(Object.assign({ type: "rectangle" }, INFINITE_BOUNDS), { toAppearance: (f, p) => f({ end1x: p.x, end1y: p.y }), fromAppearance: a => P(a.end1x, a.end1y), scale: 1.0, constraints(a, modifiers) {
                    if (modifiers.shift) {
                        let delta = new Point(a.end1x, a.end1y).subtract([a.end2x, a.end2y]);
                        let axis = delta.clone();
                        axis.angle = Math.round(delta.angle / 45) * 45;
                        let modifiedDelta = delta.project(axis);
                        return {
                            end1x: a.end2x + modifiedDelta.x,
                            end1y: a.end2y + modifiedDelta.y
                        };
                    }
                    return;
                }, snapping: !Flags.isShapeSnappingEnabled ? undefined
                    : (_, point) => ({ type: "shape_end", at: point }) }),
            Object.assign(Object.assign({ type: "rectangle" }, INFINITE_BOUNDS), { toAppearance: (f, p) => f({ end2x: p.x, end2y: p.y }), fromAppearance: a => P(a.end2x, a.end2y), scale: 1.0, constraints(a, modifiers) {
                    if (modifiers.shift) {
                        let delta = new Point(a.end2x, a.end2y).subtract([a.end1x, a.end1y]);
                        let axis = delta.clone();
                        axis.angle = Math.round(delta.angle / 45) * 45;
                        let modifiedDelta = delta.project(axis);
                        return {
                            end2x: a.end1x + modifiedDelta.x,
                            end2y: a.end1y + modifiedDelta.y
                        };
                    }
                    return;
                }, snapping: !Flags.isShapeSnappingEnabled ? undefined
                    : (_, point) => ({ type: "shape_end", at: point }) }),
        ];
    }
    render(a) {
        const graphic = new Path(Segments([[a.end1x, a.end1y]], [[a.end2x, a.end2y]]));
        BasicShapes.StrokeOnly.apply(graphic, a);
        if (a.dashed) {
            graphic.dashArray = [10, 8];
        }
        return {
            graphic,
            hitShape: { type: "stroke", path: graphic.clone() },
            pivot: P(0, 0),
            snapping: !Flags.isShapeSnappingEnabled ? undefined : [
                { type: "shape_end", at: P(a.end1x, a.end1y) },
                { type: "shape_end", at: P(a.end2x, a.end2y) },
            ]
        };
    }
}
Line.properties = {
    label: "Line",
    defaultAppearance: Object.assign({ end1x: -100, end1y: 100, end2x: 100, end2y: -100, dashed: false }, BasicShapes.StrokeOnly.defaultAppearance),
    appearanceSpecs: [
        ...BasicShapes.StrokeOnly.specs,
        BasicShapes.header,
        { spec: "checkbox", key: "dashed", label: "Dashed" },
    ],
    actions: [
        {
            type: "replace", label: "Convert to curve", icon: "wave-sine",
            action: (a, p) => {
                let p1 = P(a.end1x, a.end1y);
                let p2 = P(a.end2x, a.end2y);
                let delta = p2.subtract(p1);
                delta.length = 50; // Set distance of the handles from their parent node.
                let pivot1 = p1.add(delta);
                let pivot2 = p2.subtract(delta);
                let apparatus = createApparatus("curve", p);
                let curve = {
                    end1x: a.end1x,
                    end1y: a.end1y,
                    end2x: a.end2x,
                    end2y: a.end2y,
                    stroke: a.stroke,
                    pivot1x: pivot1.x,
                    pivot1y: pivot1.y,
                    pivot2x: pivot2.x,
                    pivot2y: pivot2.y,
                    strokeThickness: a.strokeThickness,
                };
                apparatus.appearance = Object.assign(Object.assign({}, apparatus.appearance), curve);
                return apparatus;
            }
        }
    ]
};
